import { render, staticRenderFns } from "./APIAccess.vue?vue&type=template&id=c1af42d0"
import script from "./APIAccess.vue?vue&type=script&lang=js"
export * from "./APIAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports